/**
 * Places — the platform's Google Places proxy (`/api/integrations/places/*`).
 *
 * The key stays on the server; the SDK is the only way a client reaches the
 * proxy (root rule 4). Two kinds of search: a street address, for the
 * profile's address picker, and a city, for the citizen setup's "city you live
 * in" (Citizen first run · D-2).
 */
import { TonnieClient } from '../client/base';
import { API_ENDPOINTS } from '../client/config';

export type PlaceSearchKind = 'address' | 'city';

export interface PlaceSuggestion {
  description: string;
  placeId: string;
  /** The city (for a city search) or the street (for an address search). */
  mainText: string;
  /** Region and country, as Google formats them. */
  secondaryText: string;
}

export class PlacesService {
  constructor(private readonly client: TonnieClient) {}

  /** `query` must be at least 2 characters — the server refuses shorter. */
  async autocomplete(
    query: string,
    options: { countries?: readonly string[]; kind?: PlaceSearchKind } = {}
  ): Promise<{ suggestions: PlaceSuggestion[] }> {
    const params: { query: string; countries?: string; kind?: PlaceSearchKind } = { query };
    if (options.countries && options.countries.length > 0) {
      params.countries = options.countries.join(',');
    }
    if (options.kind) params.kind = options.kind;
    return this.client.get<{ suggestions: PlaceSuggestion[] }>(
      API_ENDPOINTS.INTEGRATIONS.PLACES_AUTOCOMPLETE,
      { params }
    );
  }
}

export function createPlacesService(client: TonnieClient): PlacesService {
  return new PlacesService(client);
}
